import React from 'react';
import { motion } from 'framer-motion';
export function ActionCTA() {
  return <section id="cta" className="relative w-full min-h-[60vh] flex items-center justify-center overflow-hidden border-t border-gridline" data-id="element-27">
      <img src="https://images.unsplash.com/photo-1530103862676-de8c9debad1d?auto=format&fit=crop&w=2000&q=80" alt="Elegant event setting" className="absolute inset-0 h-full w-full object-cover" data-id="element-28" />
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" aria-hidden="true" data-id="element-29" />

      <div className="relative z-10 px-6 text-center max-w-4xl mx-auto py-24" data-id="element-30">
        <motion.span initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-accent font-bold uppercase tracking-[0.4em] text-xs md:text-sm block mb-6" data-id="element-31">
          Let's Create Something Extraordinary
        </motion.span>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-white font-black uppercase leading-[0.9] tracking-tight text-4xl sm:text-6xl md:text-7xl mb-12" data-id="element-32">
          Ready to Elevate
          <br data-id="element-33" />
          Your Next Event?
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-34">
          <a href="#book" className="inline-block bg-accent text-black font-black uppercase tracking-[0.3em] text-sm md:text-base px-10 py-5 hover:bg-white transition-colors focus:outline-none focus:ring-2 focus:ring-white" data-id="element-35">
            Start Planning
          </a>
        </motion.div>
      </div>
    </section>;
}